import { type StateType } from '../../states';
import { type EntitiesState } from '../../states/entities';
import { type Selector } from '../../types/selectors';

export const selectEntitiesState: Selector<EntitiesState> = (state: StateType) => state.entities;
